import React, { useState, useEffect } from "react";
import Breadcrumbs from "../../reusebale/breadcrumbs";
import ParagraphTag from "../../reusebale/Paragraph";
import ImageTag from "../../reusebale/imageTag";
import db from "../../../db/index.json";
import ReactPaginate from "react-paginate";
import { Grid2x2 } from "lucide-react";
import { useSelector } from "react-redux";
import BaseUrl from "../../../constants/BaseUrl";
import moment from "moment";
const Notification = ({ onBack }) => {
  const { notification } = db;
  const { loginSuccess } = useSelector((state) => state.auth);
  const [data, setData] = useState([
    {
      createdAt: "2025-04-23T13:25:15.543Z",
      description:
        "The maintenance request status has been updated for the property Fortune Tower",
      landlordId: "6808e67178b2e1875a9d24fb",
      title: "Maintenance Request Update",
      updatedAt: "2025-04-23T13:25:15.543Z",
      __v: 0,
      _id: "6808ea3b78b2e1875a9d2742",
    },

 
    
  ]);

  const [currentPage, setCurrentPage] = useState(0);
  const [switchLayout, serSwitchLayout] = useState(false);
  const itemsPerPage = 10;

  const paginatedData = data.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
  };

  const handleToggle = () => {
    serSwitchLayout((prevState) => !prevState); // वैल्यू को true/false के बीच टॉगल करें
  };

  const [notifications, setNotification] = useState([]);

  const GetAllNotification = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      landlordIds: loginSuccess.user.landlordId,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/notification/getNotificationsByLandlordIds`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          setNotification(result.data);
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    GetAllNotification();
  }, []);

  return (
    <div className="w-full h-screen">
      <div className="h-[10vh] flex items-center">
        <Breadcrumbs
          classes={`text-darkColor font-popinsSemiBold text-xl`}
          content={`${notifications?.length} Notifications`}
          onBack={onBack}
          subheading={notification.subTitle}
        />
      </div>
      <div className="h-[90vh]">
        <div className="bg-white rounded-xl h-[98%]">
          <div className="w-[95%] mx-auto pt-5 h-full">
            <div className="flex justify-between h-[12%]">
              <ParagraphTag
                content={notification.heading}
                classes={`text-darkColor font-popinsSemiBold text-lg `}
              />
              <button
                className="border-[#6F6F6F]/70 border rounded-md flex items-center justify-center px-4 h-8 text-xs font-popinsMedium text-[#6F6F6F]"
                onClick={handleToggle}
              >
                <Grid2x2 color="#6F6F6F" size={15} />
                <span className="pl-2">Switch layout</span>
              </button>
            </div>
            <div className="overflow-scroll w-full h-[88%] panelScroll">
              <div className="flex flex-wrap justify-between">
                {notifications.map((item, i) => (
                  <div
                    className={`${
                      switchLayout ? "w-full" : "w-[49%]"
                    } my-2 py-2 bg-slate-50 flex pl-4 items-center rounded-md`}
                  >
                    <ImageTag
                      classes={`w-[38px] h-[38px]`}
                      path={"/assets/daashboard/notification-color.png"}
                      altText="logo"
                    />

                    <div className="px-2">
                      <ParagraphTag
                        content={item?.title}
                        classes={`text-orangeColor font-popinsSemiBold text-xs `}
                      />
                      <ParagraphTag
                        content={item?.description}
                        classes={`text-darkColor font-popinsSemiBold text-sm `}
                      />

                      <ParagraphTag
                        content={moment(item?.createdAt).format(
                          "MM/DD/YYYY, h:mm A"
                        )}
                        classes={`text-darkColor/40 font-popinsregular text-xs `}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="flex justify-center items-center h-[13%]"> */}
          {/* <ReactPaginate
            previousLabel="Previous"
            nextLabel="Next"
            breakLabel="..."
            pageCount={Math.ceil(data.length / itemsPerPage)}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName="flex space-x-2 items-center"
            pageClassName="px-3 py-1 border rounded-md text-sm font-popinsMedium cursor-pointer"
            previousClassName="px-3 py-1 border rounded-l-md text-sm cursor-pointer font-popinsMedium"
            nextClassName="px-3 py-1 border rounded-r-md text-sm font-popinsMedium cursor-pointer font-popinsMedium"
            disabledClassName="opacity-50 !cursor-not-allowed"
            activeClassName="bg-themeColor text-white"
            breakClassName="px-3 py-1 text-sm font-popinsMedium"
          /> */}
        {/* </div> */}
      </div>
    </div>
  );
};

export default Notification;
